module.exports = __webpack_public_path__ + "676d4e85208a5ad108ad4c7e06c36f7a.webp";